var render = function () {
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:[
      _vm.$style.trigger,
      ( _obj = {}, _obj[_vm.$style.right] = _vm.arrowPosition === _vm.POSITION_RIGHT, _obj[_vm.$style.top] = _vm.arrowPosition === _vm.POSITION_TOP, _obj ) ],style:(_vm.triggerStyle),on:{"click":_vm.toggleVisibility}},[_vm._t("trigger"),(!_vm.isDisabled)?_vm._t("icon",function(){return [_c('NavArrowIcon',{class:_vm.$style.icon,attrs:{"is-visible":_vm.computeVisibility}})]}):_vm._e()],2),_c('div',{class:[
      _vm.$style.content,
      ( _obj$1 = {}, _obj$1[_vm.$style.isVisible] = _vm.computeVisibility, _obj$1 ) ]},[_vm._t("content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }